import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import AssessmentQuestion from './assessment-question-node';
import {shuffleArray} from '../../../../../utilities/common';
import {gradeModuleGradeItem,gradeModuleGradeItemAssessment,gradeModuleGradeItemQuest} from '../../../../../utilities/api';
import {filterNodeProperties} from '../../../../../utilities/filter-node-properties';
import {isEmpty} from '../../../../../utilities/validation';
import {fetchMyAssignment} from '../../../../../actions/jre';
import {formatErrors} from '../../../../../actions/errors';
import PreAssessment from './pre-assessment';
import PostAssessment from './post-assessment';
import {withRouter} from 'react-router-dom';
var getLang = function () {
  var l = localStorage.getItem('stuLang');
  return l ? l : 'en';
};

var t = function (enText, esText) {
  return getLang() === 'es' ? esText : enText;
};

var translateAssessmentName = function(name) {
  if (!name) return '';

  var lower = name.toLowerCase();

  if (lower === 'module guide') return 'Guía del módulo';
  if (lower === 'post test') return 'Prueba final';
  if (lower === 'engagement survey') return 'Encuesta de participación';
  if (lower.indexOf('pop quiz') !== -1) {
    return name.replace('Pop Quiz', 'Cuestionario');
  }
  if (lower.indexOf('rca') !== -1) {
    return name; // keep RCA as-is
  }

  return name;
};

const getDataFromAssessmentQuestionNode = function (node) {
    const keys = ['id', 'audio', 'image', 'point_value','type','title'];
    return filterNodeProperties(node, keys, {val: node.val, answers: []});
};

const getDataFromAssessmentAnswerNode = function (node) {
    const keys = ['id', 'correct', 'type','feedbacktext','feedbackmultichoice'];
    return filterNodeProperties(node, keys, {val: node.val});
};

const getDataFromNode = function (node) {
    const keys = ['name', 'assessment_type', 'points_possible', 'graded',
        'randomize', 'show_correct_feedback', 'background'];
    return filterNodeProperties(node, keys, {});
};

//helper function that returns the number of questions in the assessment node
//we use it in setUpCurrentQuestionScores
const getAssessmentLength = (node) =>{
    let count=0;
    for (let i=0;i<node.children.length;i++){
        if(node.children[i].name){
            if (node.children[i].name==='assessment_question_node'){
                count +=1;
            }
        }
    }
    return count;

};

//when moving to the next question, we return the correct statusMessage here
//used in checkPrePostAnswer, checkRcaAnswer
const getProceedStatusMessage = (totalQuestions, currentQuestionIndex) => {
  let statusMessage;

  if (totalQuestions === currentQuestionIndex + 1) {
    statusMessage = t(
      'Please Continue to finish.',
      'Por favor continúe para finalizar.'
    );
  } else {
    statusMessage = t(
      'Click Continue to move to the next question.',
      'Haga clic en Continuar para pasar a la siguiente pregunta.'
    );
  }

  return statusMessage;
};

//either generate or append to a grade list for the users taking an assessment
//used in checkPrePostAnswer, checkRcaAnswer
const generateGrades = (grades, activeUser, points, question, updatedQuestionScores, currentQuestionIndex ) => {
    let userGrade = {
        userId: activeUser.id,
        userName: `${activeUser.firstName} ${activeUser.lastName}`,
        points: points,
        answers: [question]
    };

    let getfieldtype = localStorage.getItem('typecheck');
    if(getfieldtype != 'text'){
        updatedQuestionScores[currentQuestionIndex][activeUser.id] += points;
    }

    // console.log(updatedQuestionScores);

    if (!isEmpty(grades)) { // initial grade list generation
        if (isEmpty(grades[1]) && grades[0].userId !== activeUser.id) { //1 user
            userGrade.answers = [];
            userGrade.points = 0;
            grades.push(userGrade);
        }
        let tempUserGrade = grades.map(oldUserGrade => {
            if (activeUser.id === oldUserGrade.userId) {
                return oldUserGrade;
            }
        });
        if (!isEmpty(tempUserGrade)) {
            if (!isEmpty(tempUserGrade[0])) {
                userGrade = tempUserGrade[0];
            }
            else if (!isEmpty(tempUserGrade[1])) {
                userGrade = tempUserGrade[1];
            }
            userGrade.answers.push(question);
        }
        userGrade.points = userGrade.points + points;
        if (userGrade.points < 0) {
            userGrade.points = 0;
        }
        grades = grades.map(grade => {
            if (grade.userId === activeUser.id) {
                grade = userGrade;
            }
            return grade;
        });
    }
    else { // if grade list is already generated, append userGrade
        grades = [];
        grades.push(userGrade);
    }
    return grades;
};

//setUpCurrentQuestionScores generates an object that retains points per question.
//this is needed for when we want to deduct points from a current question, and not the total assessment points
//used once in getAssessmentDetails, then saved in state
const setUpCurrentQuestionScores = (userAssessmentProgress, node) => {
    const assessmentLength = getAssessmentLength(node);

    const user1Id = userAssessmentProgress[0].id;
    const user2Id = (userAssessmentProgress[1] ? userAssessmentProgress[1].id : null);

    let currentQuestionScores = {};

    for (let i = 0; i<assessmentLength;i++){
        let newQuestionScores = {[user1Id]: 0};
        if(user2Id){ //when user2 isn't present, don't setup scores for them
            newQuestionScores = {...newQuestionScores, ...{[user2Id]: 0}};
        }
        currentQuestionScores = {...currentQuestionScores, [i]: newQuestionScores};
    }
    return currentQuestionScores;
};

const getStateFromProps = function(props = {}) {
    const node = getDataFromNode(props.node);
    return {
        ...node,
        totalQuestions: 0,
        currentQuestionIndex: 0,
        questionsList: [],
        isAssessmentInProgress: false,
        answerListOb: {},
        statusMessage: t('Select the correct answer.','Selecciona la respuesta correcta'),
        answerMessage: '',
        overlayMask: false,
        isAnswerSubmitted: false,
        answerAttempts: 0,
        totalPointsAchieved: 0,
        maxAttempts: (node.assessment_type === 'together') ? 2 : 1,
        isRCA: node.assessment_type === 'together',
        isPrePost: node.assessment_type === 'individual',

    };
};

class AssessmentNodePage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getStateFromProps(props),
            assessmentComplete: false,
            assessmentGradeType: '',
            userAssessmentProgress: {},
            activeUser: {},
            grades: {},
            waitingUser : {},
            doneUser: {}, //The user that first completes PrePost
            restartTest: false,
            activeUserAnswered: false,
            activeUserCorrect: false,
            waitingUserCorrect: false,
            totalAnswerAttempts: 0,
            showMultiUserFeedback: false, //show feedback + continue button after turns 2,4 in multiUser RCA sessions,
            currentQuestionScores: {}, //retains the scores of each individual question, initialized in getAssessmentDetails,
            multiStudentRca: false, //true for multi-user RCAs, initialized in getAssessmentDetails
            finalUserPrePost: false, //true for single user PrePost, or for User2 in PrePost, initialized in getAssessmentDetails
            assessmentPointsAvailable: 0,
            feedbacktext:''
        };
        this.getAssessmentDetails = this.getAssessmentDetails.bind(this);
        this.completeAssessment = this.completeAssessment.bind(this);
        this.submitAssessmentGrade = this.submitAssessmentGrade.bind(this);
        this.continueAssessment = this.continueAssessment.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.node !== nextProps.node) {
            this.setState({
                ...getStateFromProps(nextProps)
            });
        }
    }

    componentDidMount() {
        const {role = '', disableJREAppPlayerContainerButtons} = this.props;
        // console.log('componentDidMount = assessment');
        // console.log(this.props);
        //if(role === 'student') {
            disableJREAppPlayerContainerButtons('takingAssessment', 'assessmentNode componentDidMount');
            const {currentMyAssignment={}, fetchMyAssignment, formatErrors} = this.props;
            // console.log(this.props.currentMyAssignment);
            fetchMyAssignment(currentMyAssignment.id).then(() => {
                // console.log('fetchMyAssignment');
                this.getAssessmentDetails();
                document.dispatchEvent(new Event('jre-assessment-start'));
            })
                .catch(err => formatErrors(err, '/assignments'));
                let pointValueResponse = "";
                pointValueResponse = localStorage.getItem('pointValue');

        //}
    }

    componentWillUnmount() {
        const {enableJREAppPlayerContainerButtons} = this.props;
        document.dispatchEvent(new Event('stop_audio'));
        document.dispatchEvent(new Event('jre-assessment-finish'));
        window.contentparams = JSON.parse(localStorage.getItem('contentparams'));//joyson
        enableJREAppPlayerContainerButtons('takingAssessment', 'assessmentNode', 'componentWillUnmount');
    }

    submitAssessmentGrade (complete = false) {
        const {currentMyAssignment = {}} = this.props;
        const {assessmentGradeType, grades, userAssessmentProgress,answerListOb ,selectedidarray} = this.state;
        // console.log(this.state);
        let tempGrades = [];
        if(complete) {
            tempGrades = grades;
        }
        else {
            userAssessmentProgress.map(user => {
                tempGrades.push({
                    userId: user.id,
                    points: 0,
                    answers: [],
                    answerListOb // joyson
                });
            });
        }
        let payload = {
            gradeType: assessmentGradeType,
            assignmentId: currentMyAssignment.id,
            grades: tempGrades,
            // selectedidarray:answerListOb.selectedidarray, //joyson
            selectedidarray:selectedidarray, //joyson
            moduletype:currentMyAssignment.moduletype,
            recordid:localStorage.getItem('recordId')
        };
        // console.log(this.props);
        if(this.props.users[0].role=='student')
        {
          if(currentMyAssignment.moduletype==7)
          {
            gradeModuleGradeItemQuest(payload,window.contentparams).then(res => {
                return true;
            });
          }
          else
          {
            // console.log(payload);
            gradeModuleGradeItem(payload,window.contentparams).then(res => {
                return true;
            });
            // console.log('gradecalled');
          }
        }
    }

    async getAssessmentDetails() {
        const { role = '', users = {},user = {},currentMyAssignment = {} } = this.props;
        const { name = {}, isRCA, isPrePost } = this.state;
        // console.log(currentMyAssignment);
        localStorage.setItem('pointValue',currentMyAssignment.users[0].pointValue); // for point value comes from api response.
        localStorage.setItem('pointpossiblefromapi',currentMyAssignment.users[0].pointPossible); // for point value comes from api response.
        // if(!isEmpty(currentMyAssignment.users[1]) && currentMyAssignment.users[1] != undefined && currentMyAssignment.users[1].pointPossible != undefined){
        //     localStorage.setItem('pointpossiblefromapiuser2',currentMyAssignment.users[1].pointPossible); // for point value comes from api response.
        // }
        // console.log(users);
        if (!isEmpty(currentMyAssignment)) {  //role === 'student' &&
            const assessmentProgress = currentMyAssignment.progress;
            const assessmentUsers = currentMyAssignment.users;
            // console.log(assessmentUsers);
            let userAssessmentProgress = users.map(user => {
                let tempUser = assessmentUsers.filter(assessmentUser => {
                    return user.id === assessmentUser.id;
                });
                // console.log(tempUser);
                // console.log(assessmentProgress[tempUser[0].id]);
                tempUser[0].progress = assessmentProgress[tempUser[0].id];
                // console.log(tempUser[0]);
                return tempUser[0];
            });
            // console.log(userAssessmentProgress);
            let assessmentComplete = true;
            let assessmentGradeType = 'pretest';
            // console.log(assessmentProgress[0]);
            if(name === 'Module Guide') {
                // userAssessmentProgress = userAssessmentProgress.map(user => {
                //     user.assessmentComplete = true;
                //     console.log(user);
                //     if(user.pretest === null) {
                //         assessmentComplete = false;
                //         user.assessmentComplete = false;
                //     }
                //     return user;
                // });
                // userAssessmentProgress = userAssessmentProgress.map(user => { // joyson


                userAssessmentProgress = userAssessmentProgress.map(user => {
                //   console.log(user);
                    user.assessmentComplete = true;
                    if(user.progress.pretest === null) {
                        assessmentComplete = false;
                        user.assessmentComplete = false;
                    }
                    return user;
                });
            }
            else if (name === 'Post Test') {
                assessmentGradeType = 'posttest';
                userAssessmentProgress = userAssessmentProgress.map(user => {
                    user.assessmentComplete = true;
                    if(user.progress.posttest === null) {
                        assessmentComplete = false;
                        user.assessmentComplete = false;
                    }
                    return user;
                });
            }
            else if (name === 'Engagement Survey') {
                assessmentGradeType = 'Engagement Survey';
                userAssessmentProgress = userAssessmentProgress.map(user => {
                     user.assessmentComplete = true;
                    if(user.progress.feedback === null) {
                        assessmentComplete = false;
                        user.assessmentComplete = false;
                    }
                    return user;
                });
            }
            else {  //sets up an RCA assessment
                let tempAssessmentName = name.toLowerCase().replace(/\s/g, '');
                assessmentGradeType = tempAssessmentName;
                userAssessmentProgress = userAssessmentProgress.map(user => {
                    user.assessmentComplete = true;
                    if(user['progress'][tempAssessmentName] === null) {
                        assessmentComplete = false;
                        user.assessmentComplete = false;
                    }
                    return user;
                });
            }

            // after userAssessmentProgress is ready, we can run setUpCurrentQuestionScores
            this.setState({currentQuestionScores: setUpCurrentQuestionScores(userAssessmentProgress, this.props.node)});


            if(assessmentComplete) {
                this.setState({
                    isAssessmentInProgress: false,
                    showPostAssessment: true,
                    currentQuestionIndex: 0
                });
            }

            let waitingUser = {};
            let activeUser = userAssessmentProgress[0];
            if(!isEmpty(userAssessmentProgress[1])){
                waitingUser = userAssessmentProgress[1];
            }
            this.setState({
                userAssessmentProgress,
                assessmentComplete,
                showPostAssessment: assessmentComplete,
                assessmentGradeType,
                activeUser,
                waitingUser,
                multiStudentRca: (isRCA && !isEmpty(waitingUser)),
                finalUserPrePost: (isPrePost && isEmpty(waitingUser)),
            });
        }
    }

    answerSelected(nodeId) {
        let {answerListOb = {}} = this.state;
        let {selectedidarray = []} = this.state; // joyson
        // console.log(answerListOb);
        for (let id in answerListOb) {
            answerListOb[id] = false;
        }
        // console.log(nodeId);
        const selected = answerListOb[nodeId];
        //selectedidarray.push(nodeId);//joyson
        //selectedidarray:selectedidarray//joyson
        // console.log(selectedidarray);
        // console.log(answerListOb);
        // console.log(this.props);
        // console.log(selected);
        this.setState({
            answerListOb: {...answerListOb, [nodeId]: !selected,selectedidarray},
            statusMessage: t(
              'Click done to enter your answer.',
              'Haga clic en Finalizar para enviar su respuesta.'
            )

        });
        // console.log(answerListOb);
    }

    isAnswerCorrect() {
        // We're assuming assessments won't allow multiple correct answers as that is what all examples indicate.
        if(localStorage.getItem('typecheck') != 'multichoice'){
            const correctAnswer = this.state.questionsList[this.state.currentQuestionIndex].answers.filter(
                answer => answer.correct === '1');
            if (correctAnswer) {
                const userProvidedAnswer = this.state.answerListOb[correctAnswer[0].id];
                // User answer match the actual correct answer to the question?
                if (userProvidedAnswer && correctAnswer[0].correct === '1') {
                    return true;
                }
            }
            return false;
        }

    }

    // checks correctness of answer for Module Guide or Post Test, saves in state
    // each user taking assessment has attempt
    checkPrePostAnswer(){
        let answerMessage = '';

        let {
            grades,
            activeUser,
            activeUserCorrect,
            currentQuestionScores,
            currentQuestionIndex,
            finalUserPrePost,
            answerAttempts,
            totalAnswerAttempts,
            selectedansid,//for getting answer id
            selectedidarray = [],
            assessmentGradeType,
        } = this.state;
        // console.log(feedbacktext);
        // console.log(this.state);
        // console.log(this.props);
        let getfeedbacktext = localStorage.getItem('feedbacktext');
        let getfieldtype = localStorage.getItem('typecheck');
        // console.log(getfeedbacktext);
        // console.log(getfieldtype);

        let updatedQuestionScores = {...currentQuestionScores};

        // User answer match the actual correct answer to the question?
          if(getfieldtype != 'text'){
            let answers = this.state.answerListOb;
            // console.log(answers);
            let ansnodeId = '';
            if(getfieldtype == 'multichoice'){
                let multichoice = JSON.parse(localStorage.getItem('feedbackmultichoice'));
                // console.log(multichoice);
                let arrayform = [];
                multichoice.map((obj,i)=>{
                    arrayform.push(obj+'~'+this.state.activeUser.id);
                })
                selectedidarray = selectedidarray.concat([arrayform]);
                // console.log(selectedidarray);
                localStorage.setItem('feedbackmultichoice',JSON.stringify([]));
            }else{
                 ansnodeId = Object.keys(answers).filter(function(key) {
                    return answers[key] == true;
                    }).map(function(key) {
                return key;
                });
                // console.log("ansnodeId"+ansnodeId);
                selectedidarray.push(ansnodeId+'~'+this.state.activeUser.id);//joyson
            }

          }else{
            selectedidarray.push(getfeedbacktext+'~'+this.state.activeUser.id);//joyson
            localStorage.setItem('feedbacktext','');
            localStorage.removeItem('typecheck');
          }
        //   console.log(selectedidarray);

          this.setState({
            selectedidarray:selectedidarray//joyson
            });
        let question = this.state.questionsList[currentQuestionIndex];
        const correctAnswerIndex = question.answers.findIndex(
            function (answer) {
                return (answer.correct === '1');
            }
        );
        const isAnswerCorrect = this.isAnswerCorrect();
        let points = 0;

        if (!isAnswerCorrect) {
            // In Pre/Posttest multi-user assessments, U1 sees generic feedback.
            if (!finalUserPrePost) {
              answerMessage = t(
              'That is incorrect.',
              'Eso es incorrecto.'
              );
            }// In Pre/Posttest multi-user assessments, U2 sees the answer.
             // If no U2 is present (single user prepost test), we show the answer
            else if (finalUserPrePost){
              answerMessage = t(
              `That is incorrect. The correct answer is ${String.fromCharCode(65 + correctAnswerIndex)}.`,
              `Eso es incorrecto. La respuesta correcta es ${String.fromCharCode(65 + correctAnswerIndex)}.`
              );
            }
            question.correct = 0;
        }
        else if (isAnswerCorrect) {
            if (answerAttempts > 1) { // half points if correct on second try
                // parseFloat twice to convert from string (results in 5.0 converted to 5, omitting the decimal).
                // points += parseFloat((parseFloat(question.point_value) / 2).toFixed(1));
                // points += parseFloat((parseFloat(this.props.users[0].pointValue) / 2).toFixed(1));
                points += parseFloat(this.props.users[0].pointValue) / 2;

            } else {
                //full points if correct on first try
                // points += parseFloat(question.point_value);
                points += parseFloat(this.props.users[0].pointValue);
            }

            question.correct = 1;
            activeUserCorrect = true;
            answerMessage = t(
            'That is correct.',
            'Eso es correcto.'
          );
        }

        const statusMessage = getProceedStatusMessage(this.state.totalQuestions,currentQuestionIndex);
        const newGrades = generateGrades(grades, activeUser, points, question, updatedQuestionScores, currentQuestionIndex,selectedansid);

        this.setState({grades: newGrades,
            answerMessage,
            statusMessage,
            isAnswerSubmitted: true,
            answerAttempts: answerAttempts + 1,
            totalAnswerAttempts: totalAnswerAttempts + 1,
            activeUserCorrect,
            currentQuestionScores: updatedQuestionScores,
            overlayMask: true,
            selectedansid,//for getting answer id
        });

        document.dispatchEvent(new Event('stop_audio'));
    }

    // checks correctness of answer for RCAs, saves in state
    // each user taking assessment has 2 attempts
    checkRcaAnswer(){
        let answerMessage = '';
        let statusMessage = '';
        let answerAttempts = this.state.answerAttempts;
        let totalAnswerAttempts = this.state.totalAnswerAttempts;
        answerAttempts += 1;
        totalAnswerAttempts += 1;

        let {
            grades,
            activeUser,
            activeUserAnswered,
            activeUserCorrect,
            waitingUserCorrect,
            currentQuestionScores,
            currentQuestionIndex,
            multiStudentRca,
            selectedidarray = []
        } = this.state;
        let updatedQuestionScores = {...currentQuestionScores};

        // User answer match the actual correct answer to the question?
          let answers = this.state.answerListOb;
          let ansnodeId = Object.keys(answers).filter(function(key) {
              return answers[key] == true;
            }).map(function(key) {
          return key;
          });
        //   console.log("ansnodeId"+ansnodeId);
        //   console.log(this.props.users[0].pointValue);
          selectedidarray.push(ansnodeId+'~'+this.state.activeUser.id);//joyson
          this.setState({
            selectedidarray:selectedidarray//joyson
          });

        let question = this.state.questionsList[currentQuestionIndex];
        // console.log(question);
        const correctAnswerIndex = question.answers.findIndex(
            function (answer) {
                return (answer.correct === '1');
            }
        );
        const isAnswerCorrect = this.isAnswerCorrect();
        let points = 0;
        let isAnswerSubmitted = true;

        //updatedQuestionScores[currentQuestionIndex][activeUser.id]!==0 is only true if User2 was right the first time, but wrong the second time
        if(!this.isAnswerCorrect() && totalAnswerAttempts > 2 && updatedQuestionScores[currentQuestionIndex][activeUser.id]!==0) {
            // points -= parseFloat((parseFloat(question.point_value)).toFixed(1));
            // points -= parseFloat((parseFloat(this.props.users[0].pointValue)).toFixed(1));
            points -= parseFloat((parseFloat(this.props.users[0].pointValue)));

         }



        // activeUser is wrong, no more attempts remain
        if (!isAnswerCorrect && (answerAttempts === this.state.maxAttempts)) {
            if (!multiStudentRca) {
              answerMessage = t(
            `That is incorrect. The correct answer is ${String.fromCharCode(65 + correctAnswerIndex)}.`,
            `Eso es incorrecto. La respuesta correcta es ${String.fromCharCode(65 + correctAnswerIndex)}.`
            );
            }
            else { //In RCAs, show answer if a single-user runs out of attempts, or if multi-user(s) failed in second attempt

                if (!activeUserCorrect && !waitingUserCorrect) {
                  answerMessage = t(
                  `Both of you are incorrect. The correct answer is ${String.fromCharCode(65 + correctAnswerIndex)}.`,
                  `Ambos están incorrectos. La respuesta correcta es ${String.fromCharCode(65 + correctAnswerIndex)}.`
                  );
                }
                else {
                  answerMessage = t(
                    `One of your answers is incorrect. The correct answer is ${String.fromCharCode(65 + correctAnswerIndex)}.`,
                    `Una de sus respuestas es incorrecta. La respuesta correcta es ${String.fromCharCode(65 + correctAnswerIndex)}.`
                    );
                }
            }
            question.correct = 0;

            statusMessage = getProceedStatusMessage(this.state.totalQuestions, currentQuestionIndex, activeUserAnswered);
            if (multiStudentRca) {
                if (totalAnswerAttempts === 1 || totalAnswerAttempts === 3) {
                    activeUserCorrect = false;
                }
                if (totalAnswerAttempts === 2 || totalAnswerAttempts === 4) {
                    waitingUserCorrect = false;
                }
            }



        //activeUser is wrong, but more attempts do remain
        } else if (!isAnswerCorrect && (answerAttempts !== this.state.maxAttempts)) {
            if(multiStudentRca) {
                if(activeUserCorrect || waitingUserCorrect){
                  answerMessage = t(
                    'One of your answers is incorrect. Please try again.',
                    'Una de sus respuestas es incorrecta. Por favor intente nuevamente.'
                    );
                }
                else {
                  answerMessage = t(
                  'Both of you are incorrect. Please try again.',
                  'Ambos están incorrectos. Por favor intente nuevamente.'
                  );
                }
            }
            else {
              answerMessage = t(
                  'That is incorrect. Please try again.',
                  'Eso es incorrecto. Por favor intente nuevamente.'
                  );
            }
            statusMessage = t(
              'Please click Continue to try again.',
              'Haga clic en Continuar para intentarlo nuevamente.'
            );
        // activeUser's answer is correct
        } else if (isAnswerCorrect) {

            // update user points
            if(multiStudentRca) {
                //full points if correct on first try
                if(totalAnswerAttempts < 3){
                    // points += parseFloat(question.point_value);
                    points += parseFloat(this.props.users[1].pointValue);
                }
                //half points if correct on second try
                else if((!activeUserCorrect && totalAnswerAttempts === 3) || (!waitingUserCorrect && totalAnswerAttempts === 4)){
                    // points += parseFloat((parseFloat(question.point_value) / 2).toFixed(1));
                    // points += parseFloat((parseFloat(this.props.users[0].pointValue) / 2).toFixed(1));
                    points += parseFloat((parseFloat(this.props.users[1].pointValue) / 2));
                }
            }
            else { //single user
                //full points if correct on first try
                if (answerAttempts > 1) {
                    // parseFloat twice to convert from string (results in 5.0 converted to 5, omitting the decimal).
                    // points += parseFloat((parseFloat(question.point_value) / 2).toFixed(1));
                    // points += parseFloat((parseFloat(this.props.users[0].pointValue) / 2).toFixed(1));
                    points += parseFloat((parseFloat(this.props.users[0].pointValue) / 2));

                //half points if correct on second try
                } else {
                    // points += parseFloat(question.point_value);
                    points += parseFloat(this.props.users[0].pointValue);
                }

                // console.log(this.props.users[0].pointValue);
            }

            //setup answerMessage, statusMessage
            if(totalAnswerAttempts === 1 || totalAnswerAttempts === 3) {
                activeUserCorrect = true;
            }
            if(totalAnswerAttempts === 2 || totalAnswerAttempts === 4) {
                waitingUserCorrect = true;
            }
            if(multiStudentRca) {
                // if one of the 2 users got the question wrong
                if(!activeUserCorrect || !waitingUserCorrect){
                    if (answerAttempts === this.state.maxAttempts){
                        // When it is the final attempt, show the correct answer
                        // Get the alphabetical label based on index position (e.g. 0 => A, 1 => b).
                        answerMessage = t(
                `One of your answers is incorrect. The correct answer is ${String.fromCharCode(65 + correctAnswerIndex)}.`,
                `Una de sus respuestas es incorrecta. La respuesta correcta es ${String.fromCharCode(65 + correctAnswerIndex)}.`
              );
                        statusMessage = getProceedStatusMessage(this.state.totalQuestions,currentQuestionIndex);
                    } else {
                        // When it isn't the final attempt, show Please Try Again
                        answerMessage = t(
                          'One of your answers is incorrect. Please try again.',
                          'Una de sus respuestas es incorrecta. Por favor intente nuevamente.'
                        );
                        statusMessage = t(
                          'Please click Continue to try again.',
                          'Haga clic en Continuar para intentarlo nuevamente.'
                        );
                    }
                }
                else {
                  answerMessage = t(
                    'Both of you are correct.',
                    'Ambos están correctos.'
                    );
                    statusMessage = getProceedStatusMessage(this.state.totalQuestions,currentQuestionIndex);
                }
            }
            else {
              answerMessage = t(
              'That is correct.',
              'Eso es correcto.'
              );
                statusMessage = getProceedStatusMessage(this.state.totalQuestions,currentQuestionIndex);
            }
            question.correct = 1;
        }
        // console.log(points);


        if (multiStudentRca) {
            if(!activeUserAnswered) {
                answerAttempts--;
            }
            activeUserAnswered = !activeUserAnswered;
        }

        const newGrades = generateGrades(grades, activeUser, points, question, updatedQuestionScores, currentQuestionIndex);

        this.setState({
            grades: newGrades,
            answerMessage,
            statusMessage,
            isAnswerSubmitted,
            answerAttempts,
            totalAnswerAttempts,
            activeUserCorrect,
            waitingUserCorrect,
            activeUserAnswered,
            currentQuestionScores: updatedQuestionScores,
            overlayMask: true, //overlay is enabled to block users from changing answers before clicking continue when viewing feedback
        }, () => {
            //When 2 students are taking an RCA together, we skip the continue button by auto-running it during odd attempts.
            //The continue button is only to be shown when showMultiUserFeedback is true, otherwise continueAssessment will autorun.
            if (multiStudentRca && (totalAnswerAttempts === 4 || totalAnswerAttempts === 2)) {
                this.setState({
                    showMultiUserFeedback: true,
                });
            } else if (multiStudentRca) {
                this.continueAssessment();
            }
        });

        document.dispatchEvent(new Event('stop_audio'));

    }

    //continueAssessment decides whether the student(s) move to the next question or stay at the current question
    //if an the assessment is a multiStudentRca, the active and waiting users are swapped here
    continueAssessment() {
        const{
            waitingUser,
            activeUser,
            currentQuestionIndex,
            activeUserCorrect,
            activeUserAnswered,
            answerAttempts,
            maxAttempts,
            multiStudentRca,
        } = this.state;

        let nextQuestionIndex = currentQuestionIndex;
        let completeCheck = false;

        // Go to next question if RCA was answered correctly or attempts number is exhausted.
        if(multiStudentRca && this.state.answerAttempts === 2) {
            completeCheck = true;
        }
        else if (this.isAnswerCorrect() || (answerAttempts >= maxAttempts)) {
            if(multiStudentRca){
                if(this.isAnswerCorrect() && activeUserCorrect && !activeUserAnswered){
                    completeCheck = true;
                }
            }
            else { //PrePost always gets one chance per question
                completeCheck = true;
            }
        }
        if(completeCheck) {
            nextQuestionIndex += 1; //move to next question

            this.setState({
                answerAttempts: 0,
                activeUserCorrect: false,
                waitingUserCorrect:false,
                totalAnswerAttempts:0,
                activeUserAnswered: false
            });

            //if no more questions exist, complete the assessment
            if (nextQuestionIndex === this.state.totalQuestions) {
                this.completeAssessment();
                return;
            }
        }

        // Get the next batch of answers for the current question.
        this.state.answerListOb = this.state.questionsList[currentQuestionIndex].answers.reduce(
            (selected, answer) => {
                return {...selected, [answer.id]: false};
            }, {}
        );

        //prepare next question, swap students if multiStudentRca
        this.setState({
            answerMessage: '',
            statusMessage: t('Select the correct answer.','Selecciona la respuesta correcta'),
            overlayMask: false,
            isAnswerSubmitted: false,
            currentQuestionIndex: nextQuestionIndex,
            showMultiUserFeedback: false,
            activeUser:(multiStudentRca ? waitingUser : activeUser),
            waitingUser:(multiStudentRca ? activeUser : waitingUser),
        });

        document.dispatchEvent(new Event('stop_audio'));
    }

    //completeAssessment submits the assessment grades to the BE, and sets up User2 for their PrePost turn if relevant
    completeAssessment() {
        let {
            activeUser={},
            waitingUser={},
            isRCA,
            finalUserPrePost,
        } = this.state;

        // single/final user PrePost hits this, RCA always hits this
        if(finalUserPrePost || isRCA){
            this.setState({
                isAssessmentInProgress: false,
                showPostAssessment: true,
                assessmentComplete: true,
                currentQuestionIndex: 0,
                overlayMask: false,
            });
            this.submitAssessmentGrade(true);
            document.dispatchEvent(new Event('stop_audio'));
        }
        // Pre/Post Test - if we are proceeding to User 2's session
        else {
            this.setState({
                isAssessmentInProgress: true,
                showPostAssessment: false,
                assessmentComplete: false,
                currentQuestionIndex: 0,
                activeUser: waitingUser,
                waitingUser: null,
                restartTest: true,
                overlayMask: true,
                isAnswerSubmitted: false,
                showMultiUserFeedback: false,
                answerMessage: '',
                statusMessage: '',
                finalUserPrePost: true,
                doneUser: activeUser,
            });
        }
    }

    startAssessment() {
      const { role = '', users = {},user = {},currentMyAssignment = {},feedbacktext } = this.props;
    //   console.log(this.props)
    //   console.log(this.state);
      let payload = {
          gradeType: "Assessment",
      };

      let payloadgrade = {
        //   gradeType: "pretest",
          gradeType:this.state.assessmentGradeType,
          grades:[{userId:'',points:0,answers:[]}],
          selectedidarray:[],
          recordid:localStorage.getItem('recordId')
      };

      if(this.props.users[0].role=='student')
      {
        // gradeModuleGradeItemAssessment(payload,window.contentparams).then(res => {
        //     return true;
        // });
        gradeModuleGradeItem(payloadgrade,window.contentparams).then(res => {
            return true;
        });

      }

        let assessmentList = [];
        const assessmentQuestions = this.props.node.childrenNamed('assessment_question_node');
        assessmentQuestions.forEach(function (node) {
            let questionsAndAnswers = getDataFromAssessmentQuestionNode(node);

            let assessmentAnswer = node.childrenNamed('assessment_answer_node');
            questionsAndAnswers.answers = assessmentAnswer.map(node => {
                return getDataFromAssessmentAnswerNode(node);
            });

            assessmentList.push(questionsAndAnswers);
        });

        // Questions will be displayed in random order if "randomize" is enabled.

        // if (this.state.randomize === '1') {
        //     assessmentList = assessmentList;
        // }

        // Get the batch of answers for the first question.
        const answerListOb = assessmentList[0].answers.reduce(
            (selected, answer) => {
                // console.log(answer);
                return {...selected, [answer.id]: false};
            }, {}
        );

        this.setState({
            answerListOb: answerListOb, questionsList: assessmentList, totalQuestions:
            assessmentList.length, isAssessmentInProgress: true, restartTest: false, overlayMask: false
        });
        if(!this.state.assessmentComplete) {
            this.submitAssessmentGrade();
        }
    }

    render() {
        const {moduleURL = ''} = this.props;
        const {
            name = '',
            background = '',
            isAssessmentInProgress = false,
            showPostAssessment = false,
            assessmentComplete = false,
            restartTest = false,
            totalPointsAchieved = 0,
            questionsList = [],
            currentQuestionIndex = 0,
            isPrePost,
            feedbacktext = ''
        } = this.state;
        const divStyle = {
            background: `#FFF url(${moduleURL}/media/${background}) center center repeat-y`,
        };
        const assessmentQuestion = questionsList[currentQuestionIndex] || null;
        return (
            <div className="node assessment-container" style={divStyle}>
            <h1 className="page-title">
{getLang() === 'es' ? translateAssessmentName(name) : name}
</h1>
                {
                    ((!isAssessmentInProgress && !showPostAssessment && !assessmentComplete) || restartTest) &&
                    <PreAssessment
                        key="pre-assessment"
                        name={name}
                        startAssessment={this.startAssessment.bind(this)}
                        exitViewer={this.props.exitViewer}
                        {...this.state}
                    />
                }
                {
                    (assessmentQuestion && isAssessmentInProgress && !restartTest) &&
                    <AssessmentQuestion
                        {...this.state}
                        answerListOb={this.state.answerListOb}
                        moduleURL={moduleURL}
                        overlayMask={this.state.overlayMask}
                        checkAnswer={(isPrePost ? this.checkPrePostAnswer.bind(this) : this.checkRcaAnswer.bind(this))}
                        continueAssessment={this.continueAssessment.bind(this)}
                        answerMessage={this.state.answerMessage}
                        statusMessage={this.state.statusMessage}
                        onAnswerSelected={this.answerSelected.bind(this)}
                        isAnswerSubmitted={this.state.isAnswerSubmitted}
                        showMultiUserFeedback={this.state.showMultiUserFeedback}
                        key={assessmentQuestion.id} {...assessmentQuestion}
                    />
                }
                {
                    (showPostAssessment && assessmentComplete && !restartTest)
                    && <PostAssessment
                        nextPage={this.props.nextPage}
                        key="post-assessment"
                        name={name}
                        {...this.state}
                        totalPointsAchieved={totalPointsAchieved}
                    />
                }
            </div>
        );
    }
}

AssessmentNodePage.propTypes = {
    node: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    // console.log(state);
    return {
        currentMyAssignment:state.auth.assignment,
        role: state.auth.users.role,
        users: state.auth.users
    };
};

const mapDispatchToProps = (dispatch) => ({
    formatErrors: (err, redirectTo) => dispatch(formatErrors(err, redirectTo)),
    fetchMyAssignment: (id) => dispatch(fetchMyAssignment(id)),
});
const AssessmentNode = connect(
    mapStateToProps,
    mapDispatchToProps
)(AssessmentNodePage);

export default withRouter(AssessmentNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/assessment/assessment-node.js